module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<!-- app navbar -->\n<app-navbar class=\"mat-elevation-z6\"></app-navbar>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main